import React, {Component} from 'react';
import heroBG from '../assets/img/productsBG.jpg';
import Header from "../components/Header/Header";
import QualitySection from "../components/ProductInfo/QualitySection";
import Section2 from "../components/ProductInfo/Section2";
import IconLegend from "../components/ProductInfo/IconLegend";
import ProductList from "../components/ProductInfo/ProductList";
import ValuesModal from "../components/Modals/ValuesModal";

import hngutils from "../assets/libs/hngutils";

class ProductInfo extends Component {
    constructor(props) {
      super(props);

      this.props.data.modal.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.image);
      });

      this.props.data.product.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.main_image);
      });
    }

    state = {
        valueModalOpen: false,
        modalSelected: ""
    };

    handleClick = (title) => {
        this.setState({
            valueModalOpen: true,
            modalSelected: title
        })
    };

    handleClose = () => {
        this.setState({
            valueModalOpen: false
        })
    };

    render() {
        const {valueModalOpen, modalSelected} = this.state;
        const {allWordpressPage, modal, product} = this.props.data;
        const pageData = allWordpressPage.edges;
        const modalData = modal.edges.map(i => {
            const {description, image, title} = i.node.acf;
            return (
              {description, image, title}
            )
        });
        const selectedModal = modalData.filter(i => {
            return i.title === modalSelected
        });
        const productData = product.edges;
        return (
          <div>
              <Header bg={heroBG} title={pageData[0].node.acf.header}/>
              <QualitySection
                onClick={(title) => this.handleClick(title)}
                subheader={pageData[0].node.acf.subheader}
                data={modalData}
              />
              {
                  valueModalOpen && (
                    <ValuesModal
                      isOpen={valueModalOpen}
                      close={() => this.handleClose()}
                      modalData={selectedModal[0]}
                    />
                  )
              }
              <Section2 content={pageData[0].node.content}/>
              <IconLegend/>
              <ProductList data={productData}/>
          </div>
        );
    }
}

export default ProductInfo;

export const productInfoQuery = graphql`
    query productInfoQuery {
        allWordpressPage(filter: {wordpress_parent: {eq: 241}}) {
            edges {
                node {
                    content
                    acf{
                        header
                        subheader
                    }
                }
            }
        }
        modal: allWordpressPost(filter: {acf: {type: {eq: "info modal"}}}) {
            edges {
                node {
                    acf {
                        title
                        description
                        image {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                    }
                }
            }
        }
        product: allWordpressPost(
            filter: {acf: {type: {eq: "product"}}}
            sort: {fields: [date]}
        ) {
            edges {
                node {
                    acf {
                        title
                        fresh
                        frozen
                        short_description
                        main_image {
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }                            
                        }
                    }
                    slug
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/product-info.js